import { flexStyle } from '@themes/mixins';
import styled from 'styled-components';

export const Root = styled.form`
  ${flexStyle({ direction: 'column', justify: 'flex-start', wrap: 'nowrap' })};
  flex: 1;
`;
export const Body = styled.div`
  ${flexStyle({ direction: 'column', justify: 'flex-start', wrap: 'nowrap' })};
  flex: 1;
`;
export const Actions = styled.div`
  margin-top: 24px;
  padding: 16px 0;
`;
